import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import CurrencyInput from "react-currency-input-field";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useDealContext} from "../../contexts/DealContext";
import useTaxStateHook from "../../hooks/useTaxStateHook";

// isCapLocked keeps the Cap column but shows a fixed, read-only switch.
export const DealPageTaxItem = ({ taxItem, isCappingDisabled, isCapLocked = false }) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { updateDealResponse, isHistorical } = useDealContext()
    const [taxState, setTaxStateWithUpdate] = useTaxStateHook(taxItem)

    const isLoading = updateDealResponse?.loading
    const isCapped = Boolean(taxState.is_capped)

    return (
        <TableRow
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
            }}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                width={isCappingDisabled ? '70%' : '55%'}
                align="left"
            >
                {taxState.name}
            </TableCell>
            {
                !isTabletOrMobile &&
                <TableCell
                    className={'DealPageFee fee-name'}
                    scope="row"
                    size={'small'}
                    width={'15%'}
                    align="center"
                >
                    <CurrencyInput
                        className={'payment-row_value disabled tax-taxable-input'}
                        prefix="$"
                        value={taxState.taxable_amount}
                        disabled={true}
                    />
                </TableCell>
            }
            {
                !isCappingDisabled &&
                <TableCell
                    align="center"
                    size={'small'}
                    className={'DealPageFee'}
                    width={'15%'}
                >
                    <Tooltip title={isCapped ? "Cap" : "Upfront"} arrow placement={'top'}>
                        <Switch
                            className={isCapLocked ? 'is-locked' : undefined}
                            disabled={isLoading || isHistorical || isCapLocked}
                            checked={isCapped}
                            onChange={() => setTaxStateWithUpdate({is_capped: !taxState.is_capped})}
                        />
                    </Tooltip>
                </TableCell>
            }
            <TableCell
                align="center"
                size={'small'}
                className={'DealPageFee'}
                width={isTabletOrMobile ? '30%' : '15%'}
            >
                <CurrencyInput
                    className={'payment-row_value disabled tax-amount-input'}
                    prefix="$"
                    value={taxState.amount}
                    disabled={true}
                />
            </TableCell>
        </TableRow>
    )
}